import React, { useRef } from 'react';
import styled from 'styled-components'
import { TypeAnimation } from 'react-type-animation';
import { Link as ScrollLink } from 'react-scroll';

const Wrapper =styled.section`
/* @media (max-width: 568px) { */
  .section{
  /* background: url(../photos/twokids.png); */
  /* background: url(../photos/video.png); */
  background: url(../photos/favour-home-banner.png);
filter: brightness(0.6);

height: 100vh;
width: 100%;
background-size: cover;
background-position: center,center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
h3{
  /* color: #fff; */
  color: #EC632F;

}
p{
  /* color: white; */
  color: #EC632F;
padding-top: 5%;
}
.scroll-div{
  position: absolute;
  bottom:0px;

}
.scroll{
  color:#EC632F;
  position: relative;
  z-index: 1;
  width: 5px;
  height: 80px;
  background: #fff;
a{
  position: absolute;
  z-index: 2;
left: -26px;
  width: 60px;
  height: 60px;
  font-size: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
}



@media (min-width: 768px) {
  .scroll-div{
  position: absolute;
  bottom: 25px;

}
.scroll{
  color:#EC632F;
  position: relative;
  z-index: 1;
  width: 5px;
  height:100px;
  background: #fff;
a{
  position: absolute;
  z-index: 2;
left: -35px;
  width: 80px;
  height: 80px;
  font-size: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
}
   .section{
height: 900px;
  }

  h3{
    font-size: 25px;
  color: #fff;
}
p{
  font-size: 20px;
  color: #fff;
padding-top: 5%;
}

}


@media (min-width: 992px) {
  .scroll-div{
  position: absolute;
  bottom: 0px;

}
.scroll{
  color:#EC632F;
  position: relative;
  z-index: 1;
  width: 5px;
  height:105px;
  background: #fff;
a{
  position: absolute;
  z-index: 2;
left: -35px;
  width: 80px;
  height: 80px;
  font-size: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
}
   .section{
height: 900px;
  }

  h3{
    font-size: 25px;
  color: #fff;
}
p{
  font-size: 20px;
  color: #fff;
padding-top: 5%;
}

}



@media (min-width: 1200px) {
  .scroll-div{
  position: absolute;
  bottom: 0px;

}
.scroll{
  color:#EC632F;
  position: relative;
  z-index: 1;
  width: 5px;
  height:105px;
  background: #fff;
a{
  position: absolute;
  z-index: 2;
left: -35px;
  width: 80px;
  height: 80px;
  font-size: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
}
   .section{
    width: 100%;
height: 100vh;
  }

  h3{
    font-size: 25px;
  color: #fff;
}
p{
  font-size: 20px;
  color: #fff;
padding-top: 5%;
}

}

`


const Hero = ({ targetRef }) => {
  return (
    <Wrapper>
      <div className="section">
        <div className="text-div">
          <h3>Welcome to</h3>
          <div style={{ paddingTop: '4%' }}>
            <TypeAnimation
              sequence={[
                'Favour Pre-School and Day Care Center',
                1000,
                'lorem ipsum doloem',
                1000,
                'Favour Pre-School and Day Care Center',
                1000,
              ]}
              speed={50}
              style={{ fontSize: '1.5em', color: 'white' }}
              repeat={Infinity}
            />
          </div>
          <p>"Your Child's Gateway to Success."</p>
        </div>
        <div className="scroll-div">
          <div className="scroll">
            <ScrollLink
              to="scroll-down-target"
              smooth={true}
              duration={500}
              offset={-50}
            >
              Scroll Down
            </ScrollLink>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Hero;

